import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4840f230"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "user-new-model",
  ref: "userNewModel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-close" }, null, -1))
const _hoisted_3 = { class: "tab-block" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "main-content" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "用户名：", -1))
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "职位：", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "组织：", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上级组织：", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "角色：", -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "手机号/账号：", -1))
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账号创建时间：", -1))
const _hoisted_20 = { class: "create-time" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账号到期时间：", -1))
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "工单账号：", -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账号状态：", -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_31 = { class: "menu-content" }

import {
  reactive, withDefaults, ref, watch,provide,computed,
} from 'vue';
import { useStore, } from 'vuex';
import moment, { Moment, } from 'moment';
import {
  Modal, Button, Input, Select, DatePicker, TreeSelect, ConfigProvider, Menu, message,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import authority from '@/components/authority/index.vue';
import { postRequest, } from '@/request/request';

interface Props {
  createVisible?: boolean,
  organizations?: any,
  roles?: any,
  selectedCompany?: any,
}
interface FormState {
  name: string | undefined,
  organizationName: string | undefined,
  apartment: string | undefined,
  position: string | undefined,
  roleName: string | undefined,
  tel: string | undefined,
  accountName: string,
  createTime: Moment,
  expirationTime: Moment | undefined,
  order: string | undefined,
  status: string | undefined,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    createVisible: { type: Boolean, default: false },
    organizations: { default: Array },
    roles: { default: Array },
    selectedCompany: { default: '' }
  },
  emits: ['cancal', 'save',],
  setup(__props: any, { emit: emits }) {

const props = __props as { createVisible: boolean, organizations: any, roles: any, selectedCompany: any }

const store = useStore();

const { Option, } = Select;
const { Item, } = Menu;

const resetData = () => ({
  name: '',
  organizationName: '',
  apartment: '',
  position: '',
  roleName: '',
  tel: '',
  accountName: '',
  createTime: moment(),
  expirationTime: moment().add(12, 'months'),
  order: '0',
  status: '1',
});



const rightInfoRef = ref<any>(null);

const itemInfo = ref<any>({});

provide(
  'itemInfo',
  computed(() => itemInfo.value)
);

const tabButton = ref<any>({
  basic: '用户信息',
  menu: '角色权限',
});

const selectTab = ref<any>('basic');

const clickTabButton = (val: string) => {
  selectTab.value = val;
};

/**
 * 查询当前id对应的对象
 * @method recursiveFind
 * @param {any[]} list 递归的数组
 * @returns {any} 递归查找
 */
const recursiveFind = (list: any): any => {
  // eslint-disable-next-line no-restricted-syntax
  for (const item of list) {
    if (item.id === props.selectedCompany) {
      return item;
    }

    if (item.children) {
      return recursiveFind(item.children);
    }
  }
};

const Form = reactive<FormState>({
  name: '',
  organizationName: '',
  apartment: '',
  position: '',
  roleName: '',
  tel: '',
  accountName: '',
  createTime: moment(),
  expirationTime: moment().add(12, 'months'),
  order: '0',
  status: '1',
});

const companyId = ref<any>();
const roleId = ref<any>();

watch(
  () => props.organizations,
  (newValue) => {
    Form.organizationName = recursiveFind(newValue)?.company;
    companyId.value = recursiveFind(newValue)?.id;
  },
  {
    deep: true,
  }
);

// 处理时间格式
const rangs = (min: number, max: number, isHasMax = true) => {
  const temp = [];

  for (let i = 0; i < max - min; i++) {
    temp.push(isHasMax ?
      max - i :
      min + i);
  }

  return temp;
};

// 不可选时间
const compareTime = (dateA:any,dateB:any) => ({
  disabledHours: () => {
    // 未选时间，小时数不晚于当前时间
    if (!dateA) {
      // 如果有开始时间且等于当前时间，则小时数不超过开始时间
      if (dateB && dateB.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
        return [...rangs(moment().hour(), 23), ...rangs(0, moment(dateB).hour(), false),];
      }

      return rangs(moment().hour(), 23);
    }
    // 选中时间为开始时间，小时数不早于开始时间
    if (dateB && dateA.format('YYYY-MM-DD') === dateB.format('YYYY-MM-DD')) {
      return rangs(0, moment(dateB).hour() + 1, false);
    }

    return [];
  },
});

/**
 * 控制到期时间比当前时间晚
 * @param {*} curValue 到期时间
 * @returns {*} 函数
 */
const disabledCheckDate = (curValue: any): any => {
  const { createTime, } = Form;

  if (!curValue) {
    return false;
  }

  return curValue.format('YYYY-MM-DD').valueOf() < createTime.format('YYYY-MM-DD').valueOf();
};

const disabledCheckTime = (date:any) => {
  const { createTime, } = Form;

  return compareTime(date, createTime);
};

const getParentNode = (value:string,list:any,parent = '') :string => {
  if (!list || list.length === 0) {
    return '';
  }

  for (let i = 0; i < list.length; i++) {
    const item = list[i];

    if (item.value === value) {
      return parent;
    }

    if (item.children) {
      const res = getParentNode(value, item.children, item.value);

      if (res) {
        return res;
      }
    }
  }

  return '';
};

/**
 * 选择组织id
 * @method handleSelectOrg
 * @param {any} value 选择的值
 * @param {any} node 当前节点
 * @returns {void}
 */
const handleSelectOrg = (value: any, node: any,extra:any): void => {
  companyId.value = node.$attrs.id;
  Form.apartment = getParentNode(value, props.organizations);
};

/**
 * 选择角色id
 * @method handleSelectRole
 * @param {any} value 选择的值
 * @returns {void}
 */
const handleSelectRole = (value: any): void => {
  roleId.value = value;

  postRequest('/role/roleMenuList',{ roleId: value, }).then((data:any) => {
    rightInfoRef.value.initSeleted(data.roleMenuList);
  });
};


const handleCancle = ():void => {
  emits('cancal');
  Object.assign(Form, resetData());
};

const handleSave = () => {
  if (Form.name === '') {
    return message.warning('请输入用户名！');
  }

  if (!Form.organizationName) {
    return message.warning('请选择组织名！');
  }

  if (Form.roleName === '') {
    return message.warning('请选择角色！');
  }

  if (Form.tel === '') {
    return message.warning('请输入手机号/账号！');
  }

  const getTerminalSelected = rightInfoRef.value.getTerminalSelected();

  if (!getTerminalSelected || !getTerminalSelected.length) {
    return message.warning('权限尚未配置，请先配置权限');
  }

  const ticketRadioChecked = rightInfoRef.value.getTicketRadioChecked();

  if (!ticketRadioChecked) {
    return message.warning('请配置工单数据权限');
  }

  const params = {
    name: Form.name,
    companyId: companyId.value,
    roleId: roleId.value,
    tel: Form.tel,
    isValid: Form.status,
    isOrderAccept: Form.order,
    expirationTime: Form.expirationTime?.format('YYYY-MM-DD HH:mm:ss'),
    position: Form.position,
    accountName: Form.accountName,
    dept: Form.apartment,
  };

  store.dispatch('userCenter/saveUser', params).then(() => {
    emits('save');
    Object.assign(Form, resetData());

    // 成功新增用户后，再修改权限
    const rightParams = rightInfoRef.value.getCurRights();
    const { dataType,menuIds, } = rightParams;

    const roleParams = {
      roleId: roleId.value,
      menuIds,
      dataType,
    };

    store.dispatch('userCenter/changeRoleGrant', roleParams);
  });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      getContainer: () => _ctx.$refs.userNewModel,
      title: "新建",
      width: selectTab.value === 'menu'?'10.6rem':'7.2rem',
      footer: false,
      visible: props.createVisible,
      onCancel: handleCancle
    }, {
      closeIcon: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(tabButton.value), (item) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(['element-item', selectTab.value === item ? 'active' : '']),
              key: item,
              onClick: ($event: any) => (clickTabButton(item))
            }, [
              _createElementVNode("span", null, _toDisplayString(tabButton.value[item]), 1)
            ], 10, _hoisted_4))
          }), 128))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_unref(Input), {
              value: _unref(Form).name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(Form).name) = $event)),
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_unref(Input), {
              value: _unref(Form).position,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(Form).position) = $event)),
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_unref(TreeSelect), {
              value: _unref(Form).organizationName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(Form).organizationName) = $event)),
              "show-search": "",
              style: {"width":"2.1rem","height":"0.32rem"},
              "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
              "allow-clear": "",
              "tree-default-expand-all": "",
              placeholder: "请选择所属组织",
              treeData: props.organizations,
              onSelect: handleSelectOrg
            }, null, 8, ["value", "treeData"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_unref(Input), {
              value: _unref(Form).apartment,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(Form).apartment) = $event)),
              placeholder: "",
              disabled: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_unref(Select), {
              value: _unref(Form).roleName,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(Form).roleName) = $event)),
              placeholder: "请选择所属角色",
              dropdownStyle: { textAlign: 'center',},
              onSelect: handleSelectRole
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.roles, (item) => {
                  return (_openBlock(), _createBlock(_unref(Option), {
                    key: item.id,
                    value: item.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.roleName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_unref(Input), {
              value: _unref(Form).tel,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(Form).tel) = $event)),
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(moment)().format("YYYY-MM-DD HH:mm:[00]")), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
              default: _withCtx(() => [
                _createVNode(_unref(DatePicker), {
                  value: _unref(Form).expirationTime,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(Form).expirationTime) = $event)),
                  disabledDate: disabledCheckDate,
                  disabledTime: disabledCheckTime,
                  format: "YYYY-MM-DD HH:[00]",
                  "show-time": { format: 'HH' },
                  placeholder: "请选择到期时间"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["locale"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_unref(Select), {
              value: _unref(Form).order,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(Form).order) = $event)),
              dropdownStyle: { textAlign: 'center',}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Option), { value: "1" }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Option), { value: "0" }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_unref(Select), {
              value: _unref(Form).status,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(Form).status) = $event)),
              dropdownStyle: { textAlign: 'center',}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Option), { value: "1" }, {
                  default: _withCtx(() => [
                    _hoisted_29
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Option), { value: "0" }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ], 512), [
          [_vShow, selectTab.value === 'basic']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_31, [
          _createVNode(authority, {
            ref_key: "rightInfoRef",
            ref: rightInfoRef,
            requestType: 'role',
            showTicketConfig: true
          }, null, 512)
        ], 512), [
          [_vShow, selectTab.value === 'menu']
        ]),
        _createElementVNode("div", { class: "operation" }, [
          _createElementVNode("button", {
            class: "btn cancle",
            onClick: handleCancle
          }, "取消"),
          _createElementVNode("button", {
            class: "btn",
            onClick: handleSave
          }, "保存")
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "width", "visible"])
  ], 512))
}
}

})